var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
    _vm.logic &&
    _vm.logic.bestellung
  )?_c('div',[(_vm.logic.bestellung.terminart == 'ABHOLUNG')?_c('DetailsAbholung',{key:"abholung"}):_vm._e(),(_vm.logic.bestellung.terminart == 'RESERVIERUNG')?_c('DetailsReservierung',{key:"reservierung"}):_vm._e(),(
      _vm.logic.bestellung.terminart == 'SOFORTBESTELLUNG'
    )?_c('DetailsSofort',{key:"sofort",attrs:{"bestellung":_vm.logic.bestellung}}):_vm._e(),(_vm.logic.bestellung.terminart == 'LIEFERUNG')?_c('DetailsLieferung',{key:"lieferung"}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }